import { render, staticRenderFns } from "./UnderstandPage.vue?vue&type=template&id=eddd021a&scoped=true&"
import script from "./UnderstandPage.vue?vue&type=script&lang=js&"
export * from "./UnderstandPage.vue?vue&type=script&lang=js&"
import style0 from "./UnderstandPage.vue?vue&type=style&index=0&id=eddd021a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddd021a",
  null
  
)

export default component.exports